import {
  ActionActiveItemChanged,
  ItemDetailsAction,
  ItemDetailsActionTypes,
  ItemDetailsItemPayload,
  ItemDetailsState,
} from './item-details.types.ts';
import { State } from '../../../app/store/state.types.ts';

const initialState: ItemDetailsState = {
  activeItem: null,
  activeItemIndex: null,
  activeItemDatasource: null,
};

const activeItemChanged = ({
  item,
  index,
  datasource,
}: {
  item: ItemDetailsItemPayload | null;
  index?: number | null;
  datasource?: string | null;
}): ActionActiveItemChanged => ({
  type: ItemDetailsActionTypes.ACTIVE_ITEM_CHANGED,
  item,
  index,
  datasource,
});

function reducer(
  state = initialState,
  action: ItemDetailsAction,
): ItemDetailsState {
  switch (action.type) {
    case ItemDetailsActionTypes.ACTIVE_ITEM_CHANGED:
      return {
        ...state,
        activeItem: action.item,
        activeItemIndex: action.index === undefined ? null : action.index,
        activeItemDatasource:
          action.datasource === undefined ? null : action.datasource,
      };
  }
  return state;
}

function selectActiveItem(state: State) {
  return state.itemDetails.activeItem;
}

function selectActiveItemIndex(state: State) {
  return state.itemDetails.activeItemIndex;
}

function selectActiveItemDatasource(state: State) {
  return state.itemDetails.activeItemDatasource;
}

export {
  reducer,
  activeItemChanged,
  selectActiveItem,
  selectActiveItemIndex,
  selectActiveItemDatasource,
};
